import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Flex,
  SimpleGrid,
  Text,
  Wrap,
  WrapItem,
  Circle,
} from "@chakra-ui/layout";
import Back from "../../../Assets/back_icon.png";
import {
  Img,
  Input,
  Textarea,
  Divider,
  CloseButton,
  Spinner,
  Modal,
  useDisclosure,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  FormLabel,
  FormControl,
  Tooltip,
} from "@chakra-ui/react";
import Chip from "./Chip";
import Custom_Button from "../../../Components/Recruiter/Button/Custom_Button";
import image1 from "../../../Assets/newImgIcon.svg";
import image2 from "../../../Assets/newVideoIcon2.svg";
import image3 from "../../../Assets/3D_Box.svg";
import uploadImgMini from "../../../Assets/imgUploadMini.svg";
import uploadIcon from "../../../Assets/uploadIcon.png";
import Iicon from "../../../Assets/Iicon.png";

import LinkIcon from "../../../Assets/link.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as api from "../../../services/api";
import Swal from "sweetalert2";
import styles from "./uploadwork.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  CheckMediaType,
  driveLinksList,
  getHeightAndWidthFromDataUrl,
  getSizeMedia,
  isBlob,
} from "helper/helper";
import { useRef } from "react";
import { useWindow } from "hooks/useWindow";
import { TagsInput } from "Components/TagInput/TagInput";
import { PhoneIcon } from "@chakra-ui/icons";

const NewUpload = () => {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const [driveLinks, setDriveLinks] = useState([]);
  const [deleteLinks, setDeleteLinks] = useState([]);
  const [driveLinksLists, setDriveLinksLists] = useState([]);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const [newFiles, setNewFiles] = useState([]);
  const [tags, setTags] = useState({
    tags: [],
    tools: [],
  });
  const [mobileView, setMobileView] = useState({
    left: true,
    middle: false,
    right: false,
  });
  const windowSize = useWindow();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const { id } = useParams();

  const [image, setImage] = useState("");
  const [video, setVideo] = useState("");
  const [projectDetails, setProjectDetails] = useState({
    title: "",
    about: "",
  });
  const [previewList, setPreviewList] = useState({});
  const [link, setLink] = useState([]);
  const [editData, setEditData] = useState({});
  const [projectTypeState, setProjectTypeState] = useState("");
  const [loading, setLoading] = useState(false);
  const [filesList, setFilesList] = useState([]);

  const navigate = useNavigate();

  // const dispatch = useDispatch();
  const students = useSelector((state) => state.student);
  const handleRemoveFile = (index) => {
    const newList = filesList.filter((_, i) => i !== index);
    setFilesList(newList);
    setDeleteLinks([...deleteLinks, filesList[index]?.name]);
    setPreviewList({
      name: newList[0]?.name,
      type: newList[0]?.type,
    });
  };

  const imageHanlder = (image) => {
    setPreviewList({
      file: image,
      name: image.name,
    });
    onClose();
  };

  useEffect(() => {
    if (id) {
      const fetch = async () => {
        const studentId = JSON.parse(localStorage.getItem("user"));
        const { data } = await api.getSingleStudentWork(id, studentId?._id);
        const tags = data.data[0].tags.split(",");
        const tools = data.data[0].tools.split(",");
        const removeNull = data.data[0]?.url.filter((item) => item !== null);
        const isEmbedURL = removeNull?.find(
          (url) =>
            url.includes("drive") ||
            url.includes("youtu.be") ||
            url.includes("youtube")
        );
        console.log("isEmbedURL", data);
        // setLink(isEmbedURL);
        setTags({
          tags: tags,
          tools: tools,
        });
        // setDriveLinksLists(driveLinks);
        setEditData(data.data[0]);
        setProjectDetails({
          title: data.data[0]?.title,
          about: data.data[0]?.about,
        });

        setProjectTypeState(data.data[0].projectType);
        const modifyURLs = data.data[0].url.map((url) => {
          return {
            name: url,
            type: CheckMediaType(url),
          };
        });
        const removeNullData = modifyURLs.filter(
          (item) => item.name !== "" || null
        );
        setFilesList(removeNullData);
        setPreviewList({
          name: data.data[0].url[0],
        });
        try {
        } catch (e) {}
      };
      fetch();
    }
  }, [id]);

  const videoHandler = (video) => {
    setVideo(video);
  };

  const ChangeMobileComp = () => {
    setMobileView((state) => ({
      ...state,
      left: false,
      right: true,
    }));
  };

  const ChangeMobileCompRight = () => {
    setMobileView((state) => ({
      ...state,
      middle: false,
      right: true,
    }));
  };

  const submitHandler = async () => {
    setLoading(true);
    const formData = new FormData();
    const projectTitle =
      ref1?.current?.value || projectDetails?.title || editData?.title;
    const projectDesc =
      ref2?.current?.value || projectDetails?.about || editData?.about;

    const tools = ref3?.current?.value || editData?.tools || tags?.tools;
    const tagsData = ref4?.current?.value || editData?.tags || tags?.tags;
    let urls = [];
    if (filesList.length > 0) {
      if (id) {
        urls = filesList.map((file) => {
          if (file.name?.includes("blob")) {
            return null;
          }
          return file.name;
        });
        urls = urls.filter((url) => url !== null);
      }
    }
    formData.append(
      "projectTitle",
      projectTitle || projectDetails?.title || editData?.title
    );
    formData.append("projectType", projectTypeState);
    formData.append(
      "about",
      projectDesc || projectDetails?.about || editData?.about
    );

    formData.append("urls", urls.toString());
    formData.append("tools", tools?.toString());
    formData.append("tags", tagsData?.toString());

    if (
      !projectTitle ||
      !projectDesc ||
      !projectTypeState ||
      !tools?.toString() ||
      !tagsData?.toString() ||
      !filesList.length
    ) {
      if (!projectTitle) {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter project title!",
        });
        return;
      }
      if (!projectDesc) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter project description!",
        });
        setLoading(false);
        return;
      }
      if (!projectTypeState) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please select project type!",
        });
        setLoading(false);
        return;
      }
      if (!tools?.toString()) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter project tools!",
        });
        setLoading(false);
        return;
      }
      if (!tagsData?.toString()) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter project tags!",
        });
        setLoading(false);
        return;
      }
      if (filesList.length === 0 || filesList[0]?.type === "image/jpeg") {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please select project files",
        });
        setLoading(false);
        return;
      }
      return;
    }
    const isImage = filesList?.find(
      (item) => item.type?.includes("image") || item.type === "image"
    );
    const isVideo = filesList?.find(
      (item) => item?.type?.includes("video") || item.type === "video"
    );
    if (!isImage && !isVideo) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please upload minimum one image for thumbnail",
      });
      setLoading(false);
      return;
    }
    if (!isImage) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select atleast one image file!",
      });
      setLoading(false);
      return;
    }

    formData.append("id", id);
    if (!id) {
      for (let i = 0; i < filesList.length; i++) {
        formData.append("files[]", filesList[i]);
      }
    }
    // formData.append("file", video);
    const isDriveLink = driveLinks?.includes("drive");
    const driveLinksArrayToString = driveLinksLists.toString();

    formData.append("driveLinks", driveLinksArrayToString);
    if (id) {
      formData.append("deleteLinks", deleteLinks.toString());
    }
    try {
      let response;
      const removeDuplicates = newFiles.filter(
        (v, i, a) => a.findIndex((t) => t.name === v.name) === i
      );
      for (let i = 0; i < removeDuplicates.length; i++) {
        formData.append("files[]", removeDuplicates[i]);
      }

      if (id) {
        if (isImage) {
          response = await api.updateStudentWork(formData);
        }
      } else {
        response = await api.uploadWork(formData);
      }

      var youtubeRegex = /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
      var imageRegex = /\.(jpeg|jpg|png|gif)$/i;

      function isValidURL() {
        if (youtubeRegex.test(students.portfolio.url)) {
        } else if (imageRegex.test(students.portfolio)) {
        }
      }
      isValidURL();
      if (response.status === 201) {
        setLoading(false);
      }
      if (response.status === 201) {
        console.log(response, "success");
        // Swal.fire("Project Created Successfully");
        Swal.fire({
          icon: "success",
          text: "Project Created Successfully",
          timer: 1300,
        });
      }
      setLoading(false);
      navigate("/hiring/student/profile");
    } catch (e) {
      setLoading(false);
    }
  };
  const dividerStyle = {
    flex: 1,
    border: "1px solid #E4E4E4",
    margin: "0 5px",
  };

  const textStyle = {
    color: "#000",
    fontSize: "14px",
    letterSpacing: "0.04em",
  };

  const projectType = [
    "NFT",
    "3D Environment",
    "Interaction Design",
    "Simulation",
    "Digital twin",
    "Unreal Experience",
  ];
  const handleSelect = (item) => {
    setProjectTypeState(item);
  };

  useEffect(() => {
    if (image && !id) {
      const size = getSizeMedia(image, "image");
      const fileAsDataURL = URL.createObjectURL(image);
      if (!size) {
        getHeightAndWidthFromDataUrl(fileAsDataURL).then((dimensions) => {
          // Do something with dimensions
          if (dimensions.width < 1280 || dimensions.height < 720) {
            Swal.fire({
              icon: "error",
              text: "Image should be 1280x720 or more",
              timer: 1300,
            });
            setImage("");
            document.getElementById("uploadImage").value = "";

            return;
          }
          const duplicate = filesList.find((item) => item === image);
          if (!duplicate) {
            setFilesList([...filesList, image]);
          }
          onClose();
        });
      } else if (size) {
        setImage("");
        document.getElementById("uploadImage").value = "";
        Swal.fire({
          icon: "error",
          text: size,
          timer: 1300,
        });
      }
      onClose();
    }
    if (video && !id) {
      const size = getSizeMedia(video, "video");
      if (!size) {
        const duplicate = filesList.find((item) => item === video);
        if (!duplicate) {
          setFilesList([...filesList, video]);
        }
        onClose();
      } else if (size) {
        setVideo("");
        document.getElementById("uplaodVideo").value = "";
        Swal.fire({
          icon: "error",
          text: size,
          timer: 1300,
        });
      }
    }

    if (video && id) {
      const size = getSizeMedia(video, "video");
      if (!size) {
        let blogURL = URL.createObjectURL(video);
        setNewFiles([...newFiles, video]);
        setFilesList([
          {
            name: blogURL + ".mp4",
            type: "video",
          },
          ...filesList,
        ]);
        setPreviewList({
          name: blogURL + ".mp4",
          type: "video",
        });
        onClose();
      } else if (size) {
        setVideo("");
        document.getElementById("uplaodVideo").value = "";
        Swal.fire({
          icon: "error",
          text: size,
          timer: 1300,
        });
      }
    }

    if (image && id) {
      const size = getSizeMedia(image, "image");
      if (!size) {
        let blogURL = URL.createObjectURL(image);
        getHeightAndWidthFromDataUrl(blogURL).then((dimensions) => {
          // Do something with dimensions
          if (dimensions.width < 1280 || dimensions.height < 720) {
            Swal.fire({
              icon: "error",
              text: "Image should be 1280x720 or more",
              timer: 1300,
            });
            setImage("");
            document.getElementById("uploadImage").value = "";

            return;
          }
          const duplicate = filesList.find((item) => item === image);
          if (!duplicate) {
            setFilesList([...filesList, image]);
          }
          setNewFiles([...newFiles, image]);
          setFilesList([
            {
              name: blogURL + ".png",
              type: "image",
            },
            ...filesList,
          ]);
          setPreviewList({
            name: blogURL + ".png",
            type: "image",
          });
          onClose();
        });
      } else if (size) {
        setImage("");
        document.getElementById("uploadImage").value = "";
        Swal.fire({
          icon: "error",
          text: size,
          timer: 1300,
        });
      }
      onClose();
    }
  }, [image, video]);

  const handleLinksChange = (e, index) => {
    setDriveLinks([e.target.value]);
    setLink(e.target.value);
  };

  const isDriveLinkValid = (link) => {
    // Regular expression pattern for Google Drive link
    // regex for google drive

    const driveLinkPattern = "https://drive.google.com";

    return link?.includes(driveLinkPattern) ? true : false;
  };

  const handleLinkUpload = () => {
    const lastDriveLink = driveLinks[driveLinks.length - 1];
    if (lastDriveLink === "") {
      Swal.fire({
        icon: "error",
        text: "Please add drive link",
        timer: 1800,
        width: "400px",
        height: "100px",
      });
    } else if (!isDriveLinkValid(lastDriveLink)) {
      Swal.fire({
        icon: "error",
        text: "Invalid Google Drive link",
        timer: 1800,
        width: "400px",
        height: "100px",
      });
    } else {
      // set link
      setDriveLinksLists([...driveLinksLists, lastDriveLink]);
      setFilesList([
        ...filesList,
        {
          name: driveLinks[driveLinks.length - 1]?.split("view")[0] + "preview",
          type: "other",
        },
      ]);
    }
    setDriveLinks("");
    setLink("");
  };

  console.log(filesList, driveLinks);

  // for mobile view
  const uploadProjectModal = () => {
    ChangeMobileCompRight();
    onClose();

    const lastDriveLink = driveLinks[driveLinks.length - 1];
    if (lastDriveLink === "") {
      Swal.fire({
        icon: "error",
        text: "Please add drive link",
        timer: 1800,
        width: "400px",
        height: "100px",
      });
    } else if (!isDriveLinkValid(lastDriveLink)) {
      Swal.fire({
        icon: "error",
        text: "Invalid Google Drive link",
        timer: 1800,
        width: "400px",
        height: "100px",
      });
    } else {
      // set link
      setFilesList([
        ...filesList,
        {
          name: driveLinks[driveLinks.length - 1]?.split("view")[0] + "preview",
          type: "other",
        },
      ]);
      setDriveLinks(driveLinksList(driveLinks));
      setLink("");
    }
  };

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.back} onClick={() => navigate(-1)}>
          <img
            style={{ height: "10px", width: "12px" }}
            src={Back}
            alt="back"
          />
          Back
        </div>

        <div className={styles.colBox}>
          {/* First Column */}
          {windowSize > 480 && (
            <div className={styles.col1}>
              <div className={styles.grp}>
                <FormControl isRequired>
                  <FormLabel className={styles.grpTitle}>
                    Project Title
                  </FormLabel>
                </FormControl>

                <input
                  className={styles.grpInput}
                  placeholder="Enter Project Name"
                  name="projectTitle"
                  ref={ref1}
                  defaultValue={editData?.title}
                  autoComplete="off"
                />
              </div>

              <div className={styles.grp}>
                <FormControl isRequired>
                  <FormLabel className={styles.grpTitle}>
                    Project Type
                  </FormLabel>
                </FormControl>
                <Wrap>
                  {projectType.map((item, index) => (
                    <Box onClick={() => handleSelect(item)}>
                      <Chip
                        name={item}
                        bg={projectTypeState === item ? "#E2DDFE" : ""}
                      />
                    </Box>
                  ))}
                </Wrap>
              </div>

              <div className={styles.grp}>
                <FormControl isRequired>
                  <FormLabel className={styles.grpTitle}>
                    About Project
                  </FormLabel>
                </FormControl>
                <textarea
                  className={styles.aboutProject}
                  placeholder="Describe your project"
                  name="about"
                  defaultValue={editData?.about}
                  ref={ref2}
                />
              </div>

              <div className={styles.grp}>
                <FormControl isRequired>
                  <FormLabel className={styles.grpTitle}>
                    Tools Used ( eg: tool1, tool2 )
                  </FormLabel>
                </FormControl>
                {/* <TagsInput setTags={setTags} tags={tags} name={'tools'} /> */}
                <input
                  className={styles.grpInput}
                  placeholder="Enter Tools Used"
                  name="projectTitle"
                  id="tools"
                  ref={ref3}
                  defaultValue={editData?.tools}
                  autoComplete="off"
                />
              </div>

              <div className={styles.grp}>
                <FormControl isRequired>
                  <FormLabel className={styles.grpTitle}>
                    Tags ( eg: tag1, tag2 )
                  </FormLabel>
                </FormControl>
                {/* <TagsInput setTags={setTags} tags={tags} name={"tags"} /> */}
                <input
                  className={styles.grpInput}
                  placeholder="Enter Tags"
                  ref={ref4}
                  // id="tags"
                  defaultValue={editData?.title}
                  autoComplete="off"
                />
              </div>

              <div className={styles.btnGrp}>
                <button
                  className={styles.finishBtn}
                  onClick={submitHandler}
                  disabled={loading}
                >
                  {loading ? <Spinner /> : "Finish"}
                </button>
                <button
                  className={styles.discardBtn}
                  onClick={() => navigate(-1, true)}
                >
                  Discard
                </button>
              </div>
            </div>
          )}
          {windowSize < 480 && mobileView.left && (
            <>
              <div>
                <>
                  <div
                    className={styles.innerBack}
                    onClick={() => navigate(-1)}
                  >
                    <img
                      style={{ height: "10px", width: "12px" }}
                      src={Back}
                      alt="back"
                    />
                    Back
                  </div>
                  <div className={styles.col1} style={{ marginTop: "0.5rem" }}>
                    <div className={styles.grp}>
                      <FormControl isRequired>
                        <FormLabel className={styles.grpTitle}>
                          Project Title
                        </FormLabel>
                      </FormControl>
                      <input
                        className={styles.grpInput}
                        value={projectDetails?.title}
                        placeholder="Enter Project Name"
                        name="projectTitle"
                        onChange={(e) =>
                          setProjectDetails({
                            ...projectDetails,
                            title: e.target.value,
                          })
                        }
                        autoComplete="off"
                      />
                    </div>

                    <div className={styles.grp}>
                      <FormControl isRequired>
                        <FormLabel className={styles.grpTitle}>
                          Project Type
                        </FormLabel>
                      </FormControl>

                      <Wrap>
                        {projectType.map((item) => (
                          <Box onClick={() => handleSelect(item)}>
                            <Chip
                              name={item}
                              bg={projectTypeState === item ? "#E2DDFE" : ""}
                            />
                          </Box>
                        ))}
                      </Wrap>
                    </div>

                    <div className={styles.grp}>
                      <FormControl isRequired>
                        <FormLabel className={styles.grpTitle}>
                          About Project
                        </FormLabel>
                      </FormControl>
                      <textarea
                        className={styles.aboutProject}
                        placeholder="Describe your project"
                        name="about"
                        value={projectDetails?.about}
                        onChange={(e) => {
                          setProjectDetails({
                            ...projectDetails,
                            about: e.target.value,
                          });
                        }}
                      />
                    </div>

                    <div className={styles.grp}>
                      <FormControl isRequired>
                        <FormLabel className={styles.grpTitle}>
                          Tools Used ( eg: tool1, tool2 )
                        </FormLabel>
                      </FormControl>
                      <input
                        className={styles.grpInput}
                        placeholder="Enter Tools Used"
                        name="projectTitle"
                        id="tools"
                        value={tags.tools?.toString()}
                        onChange={(e) => {
                          setTags({
                            ...tags,
                            tools: e.target.value?.split(","),
                          });
                        }}
                        defaultValue={editData?.tools}
                        autoComplete="off"
                      />
                    </div>

                    <div className={styles.grp}>
                      <FormControl isRequired>
                        <FormLabel>Tags ( eg: tag1, tag2 )</FormLabel>
                      </FormControl>
                      {/* <TagsInput setTags={setTags} tags={tags} name={"tags"} /> */}
                      <input
                        className={styles.grpInput}
                        placeholder="Enter Tags"
                        // ref={ref4}
                        value={tags.tags?.toString()}
                        onChange={(e) => {
                          setTags({
                            ...tags,
                            tags: e.target.value?.split(","),
                          });
                        }}
                        // id="tags"
                        defaultValue={editData?.title}
                        autoComplete="off"
                      />
                    </div>

                    <div className={styles.btnGrp}>
                      <button
                        className={styles.finishBtn}
                        style={{ width: "100%", marginTop: "1rem" }}
                        onClick={ChangeMobileComp}
                        disabled={loading}
                      >
                        {loading ? <Spinner /> : "Next"}
                      </button>
                    </div>
                  </div>
                </>
              </div>
            </>
          )}

          {/* Second Column */}
          {windowSize > 480 && (
            <div className={styles.col2}>
              <p className={styles.uploadHeading}>Upload files for project</p>
              <div className={styles.uploadFlex}>
                {/* Photo */}
                <div className={styles.uploadbox}>
                  <label htmlFor="uploadImage">
                    <Circle
                      cursor={"pointer"}
                      size={84}
                      bg={"rgba(108, 86, 251, 0.09)"}
                    >
                      <Img src={image1} />
                    </Circle>
                  </label>
                  <input
                    id="uploadImage"
                    type="file"
                    accept="image/jpeg, image/png, image/gif, image/jpg"
                    onChange={(e) => setImage(e.target.files[0])}
                    hidden
                  />
                  <p className={styles.uploadText}>Image</p>
                </div>
                {/* Video */}
                <div className={styles.uploadbox}>
                  <label htmlFor="uplaodVideo">
                    <Circle
                      cursor={"pointer"}
                      size={84}
                      bg={"rgba(108, 86, 251, 0.09)"}
                    >
                      <Img src={image2} />
                    </Circle>
                  </label>

                  <input
                    id="uplaodVideo"
                    type="file"
                    accept="video/mp4,video/x-m4v,video/mkv,video/avi,video/mov,video/3gp,video/webm"
                    onChange={(e) => setVideo(e.target.files[0])}
                    hidden
                    style={{ cursor: "pointer" }}
                  />

                  <p className={styles.uploadText}>Video</p>
                </div>
                {/* 3d model */}
                {/* <div className={styles.uploadbox}>
                  <label htmlFor='upload3D'>
                    <Circle
                      cursor={'pointer'}
                      size={84}
                      bg={'rgba(108, 86, 251, 0.09)'}
                    >
                      <Img src={image3} />
                    </Circle>
                  </label>
                  <input
                    id='upload3D'
                    type='file'
                    accept='image/jpeg, image/png, image/gif, image/jpg'
                    onChange={(e) => setImage(e.target.files[0])}
                    hidden
                  />
                  <p className={styles.uploadText}>3D File</p>
                </div> */}
              </div>
              <p
                style={{
                  fontWeight: "500px",
                  fontFamily: "Roboto",
                  letterSpacing: "0.04em",
                  fontSize: "13px",
                }}
              >
                (1280x720 resolutions and higher are supported for both images
                and videos. )
              </p>
              {/* Partition */}
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <div style={dividerStyle}></div>
                <div style={textStyle}>or</div>
                <div style={dividerStyle}></div>
              </div>

              {/* post link */}
              <div className={styles.postDiv}>
                <p className={styles.postTitle}>Google Drive Link1</p>
                <div className={styles.postFlex}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid #b3b3b3",
                      borderRadius: "5px",
                      padding: "5px",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Enter Google Drive Link "
                      value={link}
                      style={{
                        width: "100%",
                        padding: "8px 16px",
                        borderRadius: "12px",
                      }}
                      onChange={handleLinksChange}
                      className={styles.postInput}
                    />
                    <Tooltip
                      label="https://drive.google.com/file/d/1KA4kALogcvbbcvYGAVvkOkBmS-v9rW6Gfukw/view?usp=share_link"
                      fontSize="md"
                    >
                      <img
                        src={Iicon}
                        alt=""
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  </div>

                  <img
                    src={uploadIcon}
                    alt="plus"
                    style={{
                      width: "29px",
                      height: "29px",
                      cursor: "pointer",
                    }}
                    onClick={handleLinkUpload}
                  />
                </div>
              </div>
              <div className={styles.info}>
                <p>
                  (Please note that images should not exceed 5MB and videos
                  should not exceed 30MB in size.)
                </p>
              </div>
            </div>
          )}

          {windowSize < 480 && mobileView.middle && (
            <div
              className={styles.col2}
              style={{ border: "none", marginTop: "8rem" }}
            >
              <p className={styles.uploadHeading}>Upload files for project</p>
              <div className={styles.uploadFlex}>
                <div className={styles.uploadbox}>
                  <label htmlFor="uploadImage">
                    <Circle
                      cursor={"pointer"}
                      size={84}
                      bg={"rgba(108, 86, 251, 0.09)"}
                    >
                      <Img src={image1} />
                    </Circle>
                  </label>
                  <input
                    id="uploadImage"
                    type="file"
                    accept="image/jpeg, image/png, image/gif, image/jpg"
                    onChange={(e) => setImage(e.target.files[0])}
                    hidden
                  />
                  <p className={styles.uploadText}>Image</p>
                </div>
                <div className={styles.uploadbox}>
                  <label htmlFor="uplaodVideo">
                    <Circle
                      cursor={"pointer"}
                      size={84}
                      bg={"rgba(108, 86, 251, 0.09)"}
                    >
                      <Img src={image2} />
                    </Circle>
                  </label>

                  <input
                    id="uplaodVideo"
                    type="file"
                    accept="video/mp4,video/x-m4v,video/mkv,video/avi,video/mov,video/3gp,video/webm"
                    onChange={(e) => setVideo(e.target.files[0])}
                    hidden
                    style={{ cursor: "pointer" }}
                  />

                  <p className={styles.uploadText}>Video</p>
                </div>
              </div>
              {/* Partition */}
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <div style={dividerStyle}></div>
                <div style={textStyle}>or</div>
                <div style={dividerStyle}></div>
              </div>
              {/* post link */}
              <div className={styles.postDiv}>
                <p className={styles.postTitle}>Google Drive Link</p>
                <div className={styles.postFlex}>
                  <img src={LinkIcon} />
                  <input
                    type="text"
                    placeholder="Enter Google Drive Link"
                    value={link}
                    style={{
                      width: "100%",
                    }}
                    onChange={(e) => setLink(e.target.value)}
                    className={styles.postInput}
                  />
                </div>
                <button
                  className={styles.finishBtn}
                  style={{ width: "100%", padding: "7px 0", marginTop: "2rem" }}
                  // onClick={ChangeMobileCompRight}
                  disabled={loading}
                  onClick={handleLinkUpload}
                >
                  {loading ? <Spinner /> : "Next"}
                </button>
              </div>
            </div>
          )}

          {/* Third Column */}
          {windowSize > 480 && (
            <div
              className={
                filesList?.length === 0 ? styles.col3Empty : styles.col3
              }
            >
              {filesList?.length === 0 ? (
                <p className={styles.col3EmptyText}>
                  Uploaded Media Preview will be shown here
                </p>
              ) : (
                <>
                  <div className={styles.preview}>
                    {CheckMediaType(
                      filesList?.find((item) => item.name === previewList?.name)
                        ?.name || filesList[filesList?.length - 1]?.name
                    ) === "image" && (
                      <Img
                        style={{
                          height: "100%",
                          width: "100%",
                          borderRadius: 12,
                        }}
                        borderRadius={12}
                        src={
                          id
                            ? isBlob(
                                filesList?.find(
                                  (item) => item.name === previewList?.name
                                )?.name
                              )
                            : URL.createObjectURL(
                                filesList?.find(
                                  (item) => item.name === previewList?.name
                                ) || filesList[filesList?.length - 1]
                              )
                        }
                      />
                    )}
                    {CheckMediaType(
                      filesList?.find((item) => item.name === previewList?.name)
                        ?.name || filesList[filesList?.length - 1]?.name
                    ) === "video" && (
                      <video
                        style={{
                          height: "100%",
                          width: "100%",
                          borderRadius: 12,
                          border: "1px solid #E7E6E8",
                          objectFit: "cover",
                        }}
                        src={
                          id
                            ? isBlob(
                                filesList?.find(
                                  (item) => item.name === previewList?.name
                                )?.name
                              )
                            : URL.createObjectURL(
                                filesList?.find(
                                  (item) => item.name === previewList?.name
                                ) || filesList[filesList?.length - 1]
                              )
                        }
                        alt="profile"
                        controls
                      />
                    )}
                    {CheckMediaType(
                      filesList?.find((item) => item.name === previewList?.name)
                        ?.name || filesList[filesList?.length - 1]?.name
                    ) === "other" && (
                      <iframe
                        style={{
                          height: "100%",
                          width: "100%",
                          borderRadius: 12,
                          border: "1px solid #E7E6E8",
                          objectFit: "cover",
                        }}
                        src={
                          filesList?.find(
                            (item) => item.name === previewList?.name
                          )?.name || filesList[filesList?.length - 1]?.name
                        }
                        alt="profile"
                        controls
                      />
                    )}
                  </div>

                  <div className={styles.pictureStack}>
                    {filesList?.map((file, index) => (
                      <>
                        {CheckMediaType(file?.name) === "image" && (
                          <Img
                            onClick={() => imageHanlder(file)}
                            style={{
                              height: "125px",
                              width: "125px",
                              cursor: "pointer",
                              borderRadius: 12,
                              border: "1px solid #E7E6E8",
                              opacity:
                                previewList?.name === file?.name ? 1 : 0.5,
                            }}
                            src={
                              id ? isBlob(file.name) : URL.createObjectURL(file)
                            }
                          />
                        )}

                        {CheckMediaType(file?.name) === "video" && (
                          <video
                            onClick={() => imageHanlder(file)}
                            src={
                              id
                                ? isBlob(file.name) + "#t=0.5"
                                : URL.createObjectURL(file) + "#t=0.5"
                            }
                            alt="profile"
                            style={{
                              height: "125px",
                              width: "125px",
                              cursor: "pointer",
                              border: "1px solid #E7E6E8",
                              objectFit: "cover",

                              opacity:
                                previewList?.name === file?.name ? 1 : 0.5,
                              borderRadius: 12,
                            }}
                          />
                        )}
                        {CheckMediaType(file?.name) === "other" && (
                          <div onClick={() => imageHanlder(file)}>
                            <iframe
                              src={id ? file?.name : file?.name}
                              alt="profile"
                              style={{
                                height: "125px",
                                width: "125px",
                                cursor: "pointer",
                                border: "1px solid #E7E6E8",
                                objectFit: "cover",
                                pointerEvents: "none",

                                opacity:
                                  previewList?.name === file?.name ? 1 : 0.5,
                                borderRadius: 12,
                              }}
                            />
                          </div>
                        )}

                        <CloseButton
                          bg={"#FF7666"}
                          color={"#fff"}
                          borderRadius={"50%"}
                          pos={"relative"}
                          size={"sm"}
                          ml={-10}
                          mt={1}
                          onClick={() => handleRemoveFile(index)}
                        />
                      </>
                    ))}
                  </div>
                </>
              )}
            </div>
          )}
          {windowSize < 480 && mobileView.right && (
            <>
              <div>
                <>
                  <div
                    className={styles.innerBack2}
                    onClick={() =>
                      setMobileView((state) => ({
                        ...state,
                        left: true,
                        right: false,
                      }))
                    }
                  >
                    <img
                      style={{ height: "10px", width: "12px" }}
                      src={Back}
                      alt="back"
                    />
                    Back
                  </div>
                  <div className={styles.preview}>
                    {filesList?.length !== 0 ? (
                      <>
                        {CheckMediaType(
                          filesList?.find(
                            (item) => item.name === previewList?.name
                          )?.name || filesList[filesList?.length - 1]?.name
                        ) === "image" && (
                          <Img
                            style={{
                              height: "100%",
                              width: "100%",
                              borderRadius: 12,
                            }}
                            borderRadius={12}
                            src={
                              id
                                ? isBlob(
                                    filesList?.find((item) => item.name)?.name
                                  )
                                : URL.createObjectURL(
                                    filesList?.find(
                                      (item) => item.name === previewList?.name
                                    ) || filesList[filesList?.length - 1]
                                  )
                            }
                          />
                        )}
                        {CheckMediaType(
                          filesList?.find(
                            (item) => item.name === previewList?.name
                          )?.name || filesList[filesList?.length - 1]?.name
                        ) === "video" && (
                          <video
                            style={{
                              height: "100%",
                              width: "100%",
                              borderRadius: 12,
                            }}
                            id="video"
                            src={
                              id
                                ? isBlob(
                                    filesList?.find(
                                      (item) => item.name === previewList?.name
                                    )?.name
                                  ) + "#t=0.5"
                                : URL.createObjectURL(
                                    filesList?.find(
                                      (item) => item.name === previewList?.name
                                    ) || filesList[filesList?.length - 1]
                                  ) + "#t=0.5"
                            }
                            alt="profile"
                            controls
                          />
                        )}

                        {CheckMediaType(
                          filesList?.find(
                            (item) => item.name === previewList?.name
                          )?.name || filesList[filesList?.length - 1]?.name
                        ) === "other" && (
                          <iframe
                            style={{
                              height: "100%",
                              width: "100%",
                              borderRadius: 12,
                              border: "1px solid #E7E6E8",
                              objectFit: "cover",
                            }}
                            src={
                              filesList?.find(
                                (item) => item.name === previewList?.name
                              )?.name || filesList[filesList?.length - 1]?.name
                            }
                            alt="profile"
                            controls
                          />
                        )}
                      </>
                    ) : (
                      <>
                        <div className={styles.emptyUpload}>
                          Uploaded media will be displayed here
                        </div>
                      </>
                    )}
                  </div>

                  <div className={styles.pictureStack}>
                    {/* <div className={styles.imgUploadmini}> */}

                    <img
                      style={{
                        height: "80px",
                        width: "80px",
                        padding: "10px 10px",
                        border: "2px dashed #CECCD1",
                        borderRadius: "12px",
                      }}
                      onClick={onOpen}
                      src={uploadImgMini}
                      alt=""
                    />
                    {/* </div> */}
                    {filesList?.map((file, index) => (
                      <>
                        {CheckMediaType(file?.name) === "image" && (
                          <Img
                            onClick={() => imageHanlder(file)}
                            className={styles.pictureStackImg}
                            style={{
                              cursor: "pointer",
                              borderRadius: 12,
                              opacity:
                                previewList?.name === file?.name ? 1 : 0.5,
                            }}
                            src={
                              id
                                ? file.name.includes("blob")
                                  ? file.name.split(".png")[0]
                                  : file.name
                                : URL.createObjectURL(file)
                            }
                          />
                        )}

                        {CheckMediaType(file?.name) === "video" && (
                          <video
                            onClick={() => imageHanlder(file)}
                            src={
                              id
                                ? isBlob(file.name)?.replace(".mp4", "") +
                                  "#t=0.5"
                                : URL.createObjectURL(file) + "#t=0.5"
                            }
                            alt="profile"
                            id={file.name}
                            className={styles.pictureStackVideo}
                            style={{
                              cursor: "pointer",
                              opacity:
                                previewList?.name === file?.name ? 1 : 0.5,
                              borderRadius: 12,
                            }}
                          />
                        )}
                        <CloseButton
                          bg={"#FF7666"}
                          color={"#fff"}
                          borderRadius={"50%"}
                          pos={"relative"}
                          size={["sm"]}
                          ml={-10}
                          mt={1}
                          onClick={() => handleRemoveFile(index)}
                        />
                      </>
                    ))}
                  </div>
                </>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <button
                  className={styles.discardBtn}
                  style={{ width: "48%" }}
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Discard
                </button>
                <button
                  className={styles.finishBtn}
                  style={{ width: "48%" }}
                  onClick={submitHandler}
                >
                  {loading ? <Spinner /> : "Finish"}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      <Modal size={"md"} isCentered={true} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent w={"95%"}>
          <ModalCloseButton />
          <div
            className={styles.col2}
            style={{ border: "none", padding: "0 1rem" }}
          >
            <p className={styles.uploadHeading}>Upload files for project</p>
            <div className={styles.uploadFlex}>
              <div className={styles.uploadbox}>
                <label htmlFor="uploadImage">
                  <Circle
                    cursor={"pointer"}
                    size={84}
                    bg={"rgba(108, 86, 251, 0.09)"}
                  >
                    <Img src={image1} />
                  </Circle>
                </label>
                <input
                  id="uploadImage"
                  type="file"
                  accept="image/jpeg, image/png, image/gif, image/jpg"
                  onChange={(e) => setImage(e.target.files[0])}
                  hidden
                />
                <p className={styles.uploadText} style={{ marginLeft: "1rem" }}>
                  Image
                </p>
              </div>
              <div className={styles.uploadbox}>
                <label htmlFor="uplaodVideo">
                  <Circle
                    cursor={"pointer"}
                    size={84}
                    bg={"rgba(108, 86, 251, 0.09)"}
                  >
                    <Img src={image2} />
                  </Circle>
                </label>

                <input
                  id="uplaodVideo"
                  type="file"
                  accept="video/mp4,video/x-m4v,video/mkv,video/avi,video/mov,video/3gp,video/webm"
                  onChange={(e) => setVideo(e.target.files[0])}
                  hidden
                  style={{ cursor: "pointer" }}
                />

                <p className={styles.uploadText} style={{ marginLeft: "1rem" }}>
                  Video
                </p>
              </div>
            </div>
            <p
              style={{
                fontWeight: "500px",
                fontFamily: "Roboto",
                letterSpacing: "0.04em",
                textAlign: "center",
                fontSize: "11px",
              }}
            >
              1280x720 resolutions and higher are supported for both images and
              videos.
            </p>
            {/* Partition */}
            <div
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              <div style={dividerStyle}></div>
              <div style={textStyle}>or</div>
              <div style={dividerStyle}></div>
            </div>
            {/* post link */}
            <div className={styles.postDiv}>
              <p className={styles.postTitle}>Google Drive Link</p>
              <div className={styles.postFlex}>
                <img src={LinkIcon} />
                <input
                  type="text"
                  placeholder="Enter Google Drive Link"
                  value={link}
                  style={{
                    width: "100%",
                  }}
                  onChange={(e) => setLink(e.target.value)}
                  className={styles.postInput}
                />
              </div>

              <button
                className={styles.finishBtn}
                style={{
                  margin: "auto",
                  width: "100%",
                  marginTop: "1rem",
                  paddingTop: "10px",
                }}
                onClick={uploadProjectModal}
                disabled={loading}
              >
                {loading ? <Spinner /> : "Next"}
              </button>
            </div>
          </div>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default NewUpload;
